import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Row, Col, Form, Input, Checkbox } from "antd";

import { login } from "./../../app.slice";
import { useLoginUserMutation } from "./login.service";
import { useTranslation } from "react-i18next";
import "./style.css";
import { ROLE } from "../../constant";

export default function Login() {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rememberDetailState, setRememberDetailState] = useState(false);

  const [loginUser, { isLoading, isSuccess, error }] = useLoginUserMutation();
  const userData = useSelector((apps) => apps.app.user);

  const onFinish = async (values) => {
    try {
      const user = await loginUser(values).unwrap();
      dispatch(login(user));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (isSuccess) {
      if (rememberDetailState) {
        localStorage.setItem(
          "rememberedUsername",
          form.getFieldValue("email")
        );
        localStorage.setItem(
          "rememberedPassword",
          form.getFieldValue("password")
        );
        localStorage.setItem("rememberDetails", "true");
      }
      if (userData.role != ROLE.SUPER_ADMIN) navigate("/home");
      else navigate("/restaurant");
    }
  }, [isSuccess, error, rememberDetailState, form, navigate, userData]);

  const onChangeRememberDetail = (e) => {
    if (!e.target.checked) {
      localStorage.removeItem("rememberedUsername");
      localStorage.removeItem("rememberedPassword");
      localStorage.removeItem("rememberDetails");
    }
    setRememberDetailState(e.target.checked);
  };

  useEffect(() => {
    const savedUsername = localStorage.getItem("rememberedUsername");
    const savedPassword = localStorage.getItem("rememberedPassword");
    const rememberFlag = localStorage.getItem("rememberDetails") === "true";

    if (savedUsername && savedPassword && rememberFlag) {
      form.setFieldsValue({ email: savedUsername, password: savedPassword });
      setRememberDetailState(true);
    }
  }, [form]);

  return (
    <div className="signincontainer">
      <Row
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <Col
          style={{ width: "100%" }}
          xs={{ span: 24 }}
          lg={{ span: 6 }}
          md={{ span: 12 }}
        >
          <div className="logocontainer">
            <img decoding="async" src={"./mark.jpg"} alt="logo" />
          </div>
          <Form
            onFinish={onFinish}
            form={form}
            layout="vertical"
            className="row-col"
          >
            <div className="signincontainer-label">{t("USERNAME")}</div>
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your email!",
                },
              ]}
            >
              <Input
                className="signincontainer-input"
                size="large"
                autoComplete="username"
              />
            </Form.Item>

            <div className="signincontainer-label">{t("PASSWORD")}</div>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password
                className="signincontainer-input"
                size="small"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Checkbox
                className="signincontainer-remember"
                checked={rememberDetailState}
                onChange={onChangeRememberDetail}
              >
                Remember details
              </Checkbox>
            </Form.Item>

            <Form.Item style={{ textAlign: "center" }}>
              <Button
                color="green"
                variant="solid"
                htmlType="submit"
                className="signincontainer-button"
                loading={isLoading}
              >
                {t("LOGIN")}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
